import { DocumentNode } from 'graphql';

import { Component, Prop, Vue } from 'vue-property-decorator';

/**
 * A template for an apollo query compoinent that deals with errors and loading.
 */
@Component({ components: {} })
export default class ExtendedApolloQuery extends Vue {
  @Prop() public query?: DocumentNode;
  @Prop() public variables?: any;
  @Prop({ default: 'cache-first' }) public fetchPolicy?: string;
}
